/**
 * Dental chart plugin manifest.
 *
 * This is the dental specialty's entry point into the chart-plugin
 * system. Future specialties (orthopaedic, neuro, ENT, …) each register
 * their own manifest from `src/charts/plugins/<specialty>/index.js`
 * and `chartPluginRegistry` picks the right one based on the viewer's
 * specialization. See `src/charts/README.md` for the plugin author
 * guide.
 *
 * Contract (kept tiny on purpose — extending this is a v1 SDK change):
 *
 *   - specialty           — unique string id ('dental')
 *   - matchSpecialization — predicate over the tour-status raw string
 *   - Component           — the chart UI rendered by ChartSlot
 *   - autoOpen            — whether the chart should auto-open on
 *                            visit-mount for this specialty (today's
 *                            dental UX preserves the existing auto-open
 *                            behaviour that lives inside the Container)
 */

import ToothChartContainer from './ToothChartContainer';
import { SPECIALIZATION_CATALOGUE } from '../../../constants/specializations';

const FREE_TEXT_DENTAL = /\bdent(al|ist)\b|odontist/i;

const dentalPlugin = {
  specialty: 'dental',
  matchSpecialization: (raw) => {
    if (!raw) return false;
    const s = String(raw).trim();
    // A catalogue code answers by its explicit flag (ORTHOPEDIC -> no chart).
    const entry = SPECIALIZATION_CATALOGUE.find((e) => e.value === s);
    if (entry) return entry.dental;
    // Other / legacy free text: whole-word dental/dentist, or *odontist.
    return FREE_TEXT_DENTAL.test(s.replace(/_/g, ' '));
  },
  Component: ToothChartContainer,
  autoOpen: true,
};

export default dentalPlugin;
